export const roaddev = [
    {
        id: 0,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "Grabaciones",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            {  titulo:"[🖥️Class] Clase 01 ",url: "https://youtu.be/n3ULyufFSzM"},        
            {  titulo:"[🖥️Class] Clase 02 ",url: "https://youtu.be/AgeIo-GQiRc"},        
            {  titulo:"[🖥️Class] Clase 03 ",url: "https://youtu.be/BPAX_Jmvgyg"},        

            {  titulo:"[🖥️Class] Clase 04 ",url: "https://youtu.be/MOa2KIVNOBM"},        


           
            

            
        ],
    },
    {
        id: 1,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "M1-Fundamentos",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            {  titulo:"[🖥️Class] Presentacion del Curso",url: "https://youtu.be/_1DEJIOcJmY?si=sMiI7jr8MpHxnkys"},        
            {  titulo:"[🖥️Class] Mi primer truco de Pronunciación",url: "https://youtu.be/gMlip7427kU?si=8b5V12RX4lRJlr-v"}, 
            {  titulo:"[🔑🖥️Code ] Mi primer truco de Pronunciación",url: "https://youtu.be/sqij4jyQ6y8"},           
            {  titulo:"[🗂️ PDF] Mi primer truco de Pronunciación",url: "https://drive.google.com/file/d/1rs0wHHmI4SmhJ8AJLhE_dB_pzJNejSd4/view?usp=sharing"},
            {  titulo:"[🗂️Slide] Palabras con T-flap Esenciales",url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},
           {  titulo:"[🔑 Password] Palabras con T-flap Esenciales",url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},

             {   titulo:"[🖥️Class] Los saludos en Ingles I",url: "https://youtu.be/xipdKtlzxAg?si=PBHynbJUK5oQGIeq"},           
            {  titulo:"[🗂️Slide] Saludos I",url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},
            {  titulo:"[🧩 Activity]  Greetings Order Words ", url: "https://wordwall.net/play/23827/026/3027"},

            {  titulo:"[🖥️Class] Los Saludos I Desafio ",url: "https://youtu.be/30nVHXUoSpQ?si=6Z20PtswjZgnYuOu"},
            { titulo:"[🗂️Slide] Saludos I Desafio",url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},
            {  titulo:"[🗂️Slide] Saludos II",url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},
            {  titulo:"[🖥️Class] The Alphabet",url: "https://www.youtube.com/watch?v=fG9ccbmA0-o"},
            {  titulo:"[🗂️Slide] The Alphabet",url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},
            {  titulo:"[🖥️Challenge] Spelling Names",url: "https://www.youtube.com/watch?v=NKZejheVK8w"},
            {  titulo:"[🗂️Slide] Spelling Names",url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},
            {  titulo:"[🖥️Solution] Spelling Names",url: "https://youtu.be/s-PqZNY9NIE"},
            {  titulo:"[🧩 Activity] The Alphabet ", url: "https://wordwall.net/play/26160/270/7301"},
            {  titulo:"[🖥️Class] A/An Indefinite Articles",url: "https://www.youtube.com/watch?v=fG9ccbmA0-o"},
            {  titulo:"[🗂️Slide] A/An Indefinite Articles ", url: "https://i.ibb.co/TK0Bz6F/Post-de-Facebook-Regreso-a-Clases-Ilustrado-Verde-3.png"},
            {  titulo:"[🧩 Activity] A/An Indefinite Articles ", url: "https://wordwall.net/play/25729/634/81869"},
            {  titulo:"[🖥️Solution] Practicando A/An Indefinite Articles",url: "https://www.youtube.com/watch?v=oJHez43MOCM&ab_channel=MyEnglishBro"},
            {  titulo:"[🧩 Activity]  A vs An Smash ", url: "https://wordwall.net/play/4085/569/17768"},
            {  titulo:"[🧩 Activity] A/An Practice II ", url: "https://wordwall.net/play/4365/798/6099"},
            {  titulo:"[🧩 Activity] A/An Practice III ", url: "https://wordwall.net/play/31221/618/8076"},
            {  titulo:"[🔑🖥️PDF] Prepositions at-in-on ",url: "https://youtu.be/ddzTxvsS1c4"},
            {  titulo:"[🗂️PDF] Prepositions at-in-on ",url: "https://drive.google.com/file/d/1oM3Lz9dr__giRI_FxXXGXGgJ5sZEOE4r/view?usp=sharing"},

          
            {  titulo:"[🔑🖥️Code] Examen 01 ",url: "https://youtu.be/byKePAB2Vfg"},
            {  titulo:"[🗂️Exam] Examen 01 ",url: "https://drive.google.com/file/d/1kw1SpRrxZR60jYb9GEX6eXI0zbEz7dwf/view?usp=sharing"},

           
            

            
        ],
    },
    {
        id: 2,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "M1-Present Simple",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            {  titulo:"[🖥️Class] The English Structure ", url: "https://youtu.be/h4uL68plGkw?si=anrtlRavkFlaRK9K"},
            {  titulo:"[🗂️Slide] The English Structure", url: "https://docs.google.com/presentation/d/161TA3DKqAAgy8HJFo_BzyM8-CxpseNXZ/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            {  titulo:"[🖥️Class] The Pronouns & Transformation", url: "https://www.youtube.com/watch?v=2Ty1I6hMq-g"},
            {  titulo:"[🗂️Slide] The Pronouns & Transformation", url: "https://docs.google.com/presentation/d/1g9oaA24WsKlcS8P32zYHtdWGiRcyAIAi/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            {  titulo:"[🖥️ Class] Prensent Simple with Be", url: "https://www.youtube.com/watch?v=HbroMBQLCyQ&ab_channel=MyEnglishBro"},
            {  titulo:"[📑 GrammarSheet] Contractions with Be",url: "https://drive.google.com/file/d/1RbxiaSl1dFwOq7sFTF_7TRRmIpapN1XN/view?usp=sharing"},

            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form I", url: "https://wordwall.net/play/13293/724/51767" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form II", url: "https://wordwall.net/play/14390/465/80013" },
            {  titulo:"[🧩 Activity] The Verb Be Affirmative Form III", url: "https://wordwall.net/play/11554/389/1088" },
            {  titulo:"[🖥️ Solution] Practicando el Verbo Be Affirmative Form", url: "https://youtu.be/Z9Y7IWFNX_Q"},
            {  titulo:"[📝 FunSheet] GRAMMAR ERROR CORRECTION BE",url: "https://drive.google.com/file/d/15RV8Qi_oXfnAjFGbZ2XE_MeZra8XPvot/view?usp=sharing"},
            {  titulo:"[🔖Practice]The Verb Be Affirmative Form",url: "https://drive.google.com/file/d/1fieorI4c7zCUt6ltKNrXlVX8aPXogvcb/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Negative Form",url: "https://drive.google.com/file/d/15uWVRNGSUj0D8zZQ-O6K-UjTiArG5TA3/view?usp=sharing" },
            {  titulo:"[🔖Practice]The Verb Be Yes/No Questions",url: "https://drive.google.com/file/d/1s7zZgtpqjsuc3i81bFhfj7PhUWrNoUX7/view?usp=sharing" },
            {  titulo:"[🖥️ Class] Adjectives", url: "https://youtu.be/CpG5KE79gFg"},
            {  titulo:"[🗂️Slide] Adjectives",url: "https://docs.google.com/presentation/d/1kfRo9rtah5D8Afgsj8zbV5iC1c1pOPju/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true"},
            {  titulo:"[🧩 Activity] The Verb Be Negative Form", url: "https://wordwall.net/play/21158/025/3896" },
            {  titulo:"[📝 FunSheet] BE VERB: Negative",url: "https://drive.google.com/file/d/1Y5UlRlzuV3TLR79_IutdZYshmYs23cIf/view?usp=sharing"},

            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form I", url: "https://wordwall.net/play/1856/077/57902" },
            {  titulo:"[🧩 Activity] The Verb Be Interrogative Form II", url: "https://wordwall.net/play/58086/380/593" },
            {  titulo:"[🖥️ Solution] Practicando el Verbo Be Negative & Interrogative Form", url: "https://youtu.be/L0yrUtFO1pE"},
       
       
        ],
    },
    {
        id: 3,
        thumbnail:
            "https://i.ibb.co/VL5G53c/My-english-bro-Personajek-09.png",
        title: "M1 - Present Tense II",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
           
            {  titulo:"[🗂️Slide] Present Simple Tense Affirmative ",url: "https://docs.google.com/presentation/d/1hWVK_6KkwKxRtWJtx0TL-A4K5oPMdUQJ/edit?usp=sharing&ouid=101677822942011312590&rtpof=true&sd=true" },
            {  titulo:"[🧩 Activity] 3rd Person Rules",url: "https://wordwall.net/play/28761/823/4170" },
            {  titulo:"[🧩 Activity] Present Simple  Affirmative Form",url: "https://wordwall.net/play/57830/431/8032" },
            {  titulo:"[🔖Practice] Spelling Changes",url: "https://drive.google.com/file/d/1dpWuDqqkIR8au1C1PERB6pOz5H-ivktU/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Affirmative Form I",url: "https://drive.google.com/file/d/1gn1jk2vGP960VU-D_9IU9QknhCfDbLQ_/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Affirmative Form II",url: "https://drive.google.com/file/d/1RMuY04Q492JcJOO8goK8-JQp9kLktCYK/view?usp=sharing" },
            {  titulo:"[🧩 Activity] Days of the week ", url: "https://wordwall.net/play/22419/293/58122"},

            {  titulo:"[🔖Practice] Present Simple Negative Form I",url: "https://drive.google.com/file/d/1dvhm4IVAk_jXGiq86I0i6lBxZzLlA7v-/view?usp=sharing" },
            {  titulo:"[🔖Practice] Present Simple Negative Form II",url: "https://drive.google.com/file/d/1BCabvvBOmmIuh6lD5XRMWwch1l0oP-54/view?usp=sharing" },        


           
            

            
        ],
    },
    
    
    
    


   
    
   
    
     
   
    


   
    
   
    
   
    
];
